import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import LoginPage from "./pages/login";
import WhatsappButton from "./components/WhatsappButton";
import AppBar from "./components/appBar";
import HomePage from "./pages/home";
import NoteRate from "./pages/noteRate";
import MyOrder from "./pages/myOrder";
import Offer from "./pages/offer";
import Profile from "./pages/profile";
import AboutUs from "./pages/aboutUs";
import { LanguageDirection } from "./signals/language.signal";
import {
  logClientBranch,
  logClientCompany,
  logClientName,
  logClientNumber,
  logToken,
  signalPagePath,
} from "./signals/login.signal";
import { jwtDecode } from "jwt-decode";
import { clearToken, isTokenValid, setTokenExpiration } from "./helpers/auth";
import Coupon from "./pages/coupons";
import More from "./pages/more";
import Product from "./pages/product";
import Card from "./pages/cart";
import CouponDetails from "./pages/couponsDetails";
import TermsAndConditions from "./pages/termsAndConditions";
import "aos/dist/aos.css";
import AOS from "aos";
import Checkout from "./pages/Checkout";
import Catalog from "./pages/Catalogs";
import OTPPage from "./pages/otp";

AOS.init();

const App = () => {
  signalPagePath.value = localStorage.getItem("b2bAppToken") !== null;
  const token = localStorage.getItem("b2bAppToken")
    ? localStorage.getItem("b2bAppToken")
    : "";
  const decoded = token ? jwtDecode(token) : "";
  const jsonToken = token ? JSON.parse(token) : "";
  logClientNumber.value = decoded ? decoded.data.clientNumber : null;
  logClientName.value = decoded ? decoded.data.clientName : null;
  logClientCompany.value = decoded ? decoded.data.clientCompanyNumber : null;
  logClientBranch.value = decoded ? decoded.data.clientBranch : null;
  logToken.value = jsonToken ? jsonToken.data : null;

  useEffect(() => {
    const expirationTimer = startTokenExpirationTimer();
    return () => clearTimeout(expirationTimer);
  }, []);

  function startTokenExpirationTimer() {
    const expirationTimer = setTimeout(() => {
      if (!isTokenValid()) {
        clearToken();
      }
    }, 60000);

    return expirationTimer;
  }

  function onUserInteraction() {
    setTokenExpiration();
  }

  useEffect(() => {
    document.addEventListener("click", onUserInteraction);
    return () => {
      document.removeEventListener("click", onUserInteraction);
    };
  }, []);

  return (
    <div className="w-100" dir={LanguageDirection.value}>
      <BrowserRouter basename="/">
        <Routes>
          <Route
            path="/"
            element={
              <>
                <LoginPage />
              </>
            }
          />
          <Route
            path="/otp"
            element={
              signalPagePath.value ? (
                <>
                  <OTPPage />
                </>
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/home"
            element={
              signalPagePath.value ? (
                <>
                  <HomePage />
                  <AppBar />
                  <WhatsappButton />
                </>
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/product"
            element={
              signalPagePath.value ? (
                <>
                  <Product />
                  <AppBar />
                  <WhatsappButton />
                </>
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/myOrder"
            element={
              signalPagePath.value ? (
                <>
                  <MyOrder />
                  <AppBar />
                  <WhatsappButton />
                </>
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/Catalog"
            element={
              signalPagePath.value ? (
                <>
                  <Catalog />
                  <AppBar />
                  <WhatsappButton />
                </>
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/card"
            element={
              signalPagePath.value ? (
                <>
                  <Card />
                  <AppBar />
                  {/* <WhatsappButton /> */}
                </>
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/Checkout"
            element={
              signalPagePath.value ? (
                <>
                  <Checkout />
                  {/* <AppBar /> */}
                  {/* <WhatsappButton /> */}
                </>
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/offer"
            element={
              signalPagePath.value ? (
                <>
                  <Offer />
                  <AppBar />
                  <WhatsappButton />
                </>
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/noteRate"
            element={
              signalPagePath.value ? (
                <>
                  <NoteRate />
                  <AppBar />
                  <WhatsappButton />
                </>
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/More"
            element={
              signalPagePath.value ? (
                <>
                  <More />
                  <AppBar />
                  <WhatsappButton />
                </>
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/coupon"
            element={
              signalPagePath.value ? (
                <>
                  <Coupon />
                  <AppBar />
                  <WhatsappButton />
                </>
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/CouponDetails"
            element={
              signalPagePath.value ? (
                <>
                  <CouponDetails />
                  {/* <AppBar /> */}
                  {/* <WhatsappButton /> */}
                </>
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/profile"
            element={
              signalPagePath.value ? (
                <>
                  <Profile />
                  {/* <AppBar />
                  <WhatsappButton /> */}
                </>
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/TermsAndConditions"
            element={
              signalPagePath.value ? (
                <>
                  <TermsAndConditions />
                  <AppBar />
                  <WhatsappButton />
                </>
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/AboutUs"
            element={
              signalPagePath.value ? (
                <>
                  <AboutUs />
                  <AppBar />
                  <WhatsappButton />
                </>
              ) : (
                <Navigate to="/" />
              )
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default App;
